import React from 'react'
import { Routes, Route, useLocation, Navigate } from 'react-router-dom'
import Gallery from '../components/Gallery'
import Upload from '../components/Upload'
import Authentication from '../components/Authentication/Authentication'
import Subscribe from '../components/Subscribe'
import {
  BirthdayCategory,
  VacationCategory,
  WeddingCategory,
  FriendsAndFamilyCategory,
  CustomCategory,
  PetsCategory,
  EventsAndLocationsCategory,
  DuplicatesCategory,
  FavoritesCategory,
  UncategorizedAssets,
  DeletedCategory
} from '../components/Gallery/Categories'
import { SearchResults } from '../components/Gallery/Search'
import Footer from '../components/Footer/Footer'
import { useAuthListener, useRootRedirectPath } from './hooks'
import ProtectedRoute from './ProtectedRoute'
import YearDocuments from '../components/Gallery/Categories/YearDocuments'

// pages that should include the app footer
const includeFooterPaths = ['/', '/auth']

function AppRouter() {
  const appLocation = useLocation()
  const redirectPath = useRootRedirectPath()
  useAuthListener()

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={redirectPath ? <Navigate to={redirectPath} replace /> : null}
        />
        <Route exact path="/auth" element={<Authentication />} />
        <Route
          exact
          path="/gallery"
          element={
            <ProtectedRoute>
              <Gallery />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/upload"
          element={
            <ProtectedRoute>
              <Upload />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/subscribe"
          element={
            <ProtectedRoute>
              <Subscribe />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/birthday-category"
          element={
            <ProtectedRoute>
              <BirthdayCategory />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/vacation-category"
          element={
            <ProtectedRoute>
              <VacationCategory />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/wedding-category"
          element={
            <ProtectedRoute>
              <WeddingCategory />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/friends-family-category"
          element={
            <ProtectedRoute>
              <FriendsAndFamilyCategory />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/college-category"
          element={
            <ProtectedRoute>
              <CustomCategory />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/pets-category"
          element={
            <ProtectedRoute>
              <PetsCategory />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/events-locations-category"
          element={
            <ProtectedRoute>
              <EventsAndLocationsCategory />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/custom-category"
          element={
            <ProtectedRoute>
              <CustomCategory />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/duplicates"
          element={
            <ProtectedRoute>
              <DuplicatesCategory />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/favorites"
          element={
            <ProtectedRoute>
              <FavoritesCategory />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/uncategorized"
          element={
            <ProtectedRoute>
              <UncategorizedAssets />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/deleted"
          element={
            <ProtectedRoute>
              <DeletedCategory />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/search"
          element={
            <ProtectedRoute>
              <SearchResults />
            </ProtectedRoute>
          }
        />
        <Route path="/documents/:year" element={<YearDocuments />} />
        <Route
          path="*"
          element={redirectPath ? <Navigate to={redirectPath} replace /> : null}
        />
      </Routes>
      {includeFooterPaths.includes(appLocation.pathname) && <Footer />}
    </>
  )
}

export default AppRouter
